import styled from 'styled-components'
import cssVar from '../../styles/variables'

export const withColor = (Item, color) => {
  return styled(Item) `
    color: ${color};
    border-color: ${color};
  `
}

export const H1 = styled.h1 `
  font-family: 'Supreme-Medium';
  font-size: 80px;
  line-height: 80px;
  letter-spacing: -0.02em;
  color: ${ (props) => props.color || cssVar.colors.blue };

  @media screen and (max-width: 1400px) {
    font-size: 72px;
    line-height: 72px;
  }

  ${cssVar.breakpoints.phone} {
    font-size: 48px;
    line-height: 56px;
  }
`

export const Centered = styled.div `
  width: 100%;
  text-align: center;
`

export const Heading1 = styled.div `
  font-family: 'Supreme-Medium';
  font-size: 52px;
  line-height: 64px;
  letter-spacing: 0.00em;
  color: ${ (props) => props.color || cssVar.colors.blue };

  ${cssVar.breakpoints.tablet} {
    font-size: 42px;
    line-height: 48px;
  }
`

export const Heading2 = styled.div `
  font-family: 'Supreme-Medium';
  font-size: 32px;
  padding: 10px 0 20px 0;
  line-height: 36px;
  letter-spacing: 0.00em;
  color: ${ (props) => props.color || cssVar.colors.blue };

  ${cssVar.breakpoints.tablet} {
    font-size: 28px;
    line-height: 36px;
  }
`

export const Heading3 = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.00em;
  text-transform: uppercase;
  color: ${ (props) => props.color || cssVar.colors.blue };
`

export const Heading4 = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.00em;
  color: ${ (props) => props.color || cssVar.colors.blue };
`

export const SectionHeading = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0.02em;
  padding: 40px 0 10px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
`

export const SectionText = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.02em;
  padding: 5px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: block;
`

export const Text = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  padding: 10px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: block;
  max-width: ${ cssVar.max_text_width }px;
`

export const CenteredText = styled(Text) `
  margin: 0 auto;
`

export const TextLink = styled.a `
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  padding: 10px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: inline-block;
  text-decoration: none;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`

export const SocialWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  a {
    transition: ${ cssVar.transitions.basic };
    padding-left: 1em;

    :hover {
      transform: scale(1.1);
    }
  }
`

export const Link = styled.a `
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  padding: 10px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: block;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-transform: uppercase;
  cursor: pointer;
`

export const LinkText = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  padding: 10px 0;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: block;
  text-transform: uppercase;
`

export const BiggerText = styled.div `
  font-family: 'Supreme-Light';
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0.00em;
  color: ${ (props) => props.color || cssVar.colors.blue };
  display: block;
  padding: 10px 0;
  max-width: ${ cssVar.max_text_width }px;

  ${cssVar.breakpoints.tablet} {
    font-size: 22px;
    line-height: 32px;
  }

  ${cssVar.breakpoints.phone} {
    padding: 15px 0;
  }
`

export const TextField = styled.input.attrs({type: 'text'}) `
  font-family: 'Supreme-Regular';
  width: 100%;
  margin: 10px 0;
  display: block;
  font-size: 14px !important;
  line-height: 20px !important;
  padding: 8px 20px;
  letter-spacing: 0.07em;
  color: ${ (props) => props.color || cssVar.colors.blue };
  border-bottom: 1px solid ${ (props) => props.color || cssVar.colors.blue };;
  background: none;
  border-radius: 0;

  &::placeholder {
    color: ${ (props) => props.color || cssVar.colors.blue };
    opacity: 0.5;
  }
`

export const SelectWrapper = styled.div `
  width: 100%;
  position: relative;
  cursor: pointer;

  ::after {
    content: "▼";
    position: absolute;
    pointer-events: none;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 10px;
    color: ${ (props) => props.color || cssVar.colors.blue };
  }
`
export const Select = styled.select `
  appearance: none;
  border: none;
  font-family: 'Supreme-Regular';
  width: 100%;
  margin: 10px 0;
  display: block;
  font-size: 14px !important;
  line-height: 20px !important;
  background: none;
  padding: 8px 40px 8px 20px;
  letter-spacing: 0.07em;
  color: ${ (props) => props.color || cssVar.colors.blue };
  border-bottom: 1px solid ${ (props) => props.color || cssVar.colors.blue };
  position: relative;
  border-radius: 0;

  &::placeholder {
    color: ${ (props) => props.color || cssVar.colors.blue }88;
  }
  &:focus {
    outline: none;
    border: none;
    border-bottom: 1px solid ${ (props) => props.color || cssVar.colors.blue };
  }
`

export const PrimaryButton = styled.input.attrs({type: 'submit'}) `
  font-family: 'Supreme-Medium';
  width: ${ (props) => props.autoWidth? 'auto' : '100%' };
  padding: 20px 48px;
  display: block;
  font-size: 14px !important;
  line-height: 20px !important;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: white;
  background: ${cssVar.colors.gold};
  appearance: none;
  border: none;
  outline: none;
  border-radius: 2px;

  transition: all ${ cssVar.transitions.basic };

  :hover {
    background: ${ cssVar.colors.dark_gold };
  }

  :disabled {
    background: ${ cssVar.colors.light_grey };
    color: ${ cssVar.colors.grey };
    cursor: not-allowed;
  }

  ${cssVar.breakpoints.phone} {
    padding: 15px 20px;
  }
`

export const PrimaryLinkButton = styled.a `
  font-family: 'Supreme-Medium';
  width: ${ (props) => props.autoWidth? 'auto' : '100%' };
  padding: 20px 48px;
  display: block;
  font-size: 14px !important;
  line-height: 20px !important;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: white;
  background: ${cssVar.colors.gold};
  appearance: none;
  border: none;
  outline: none;
  border-radius: 2px;

  transition: all ${ cssVar.transitions.basic };

  :hover {
    background: ${ cssVar.colors.dark_gold }
  }

  ${cssVar.breakpoints.phone} {
    padding: 15px 20px;
  }
`

export const SecondaryButton = styled.input.attrs({type: 'submit'}) `
  font-family: 'Supreme-Medium';
  width: ${ (props) => props.autoWidth? 'auto' : '100%' };
  padding: 20px 48px;
  display: inline-block;
  font-size: 14px !important;
  line-height: 20px !important;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: ${cssVar.colors.gold};
  border: 1px solid ${cssVar.colors.gold};
  background: none;
  appearance: none;
  outline: none;
  border-radius: 2px;

  transition: all ${ cssVar.transitions.basic };

  :hover {
    background: ${ cssVar.colors.dark_gold };
    border-color: ${ cssVar.colors.dark_gold };
    color: white;
  }

  :disabled {
    background: ${ cssVar.colors.light_grey };
    color: ${ cssVar.colors.grey };
    cursor: not-allowed;
    border-radius: none;
  }

  ${cssVar.breakpoints.phone} {
    padding: 15px 20px;
  }
`

export const NoticeText = styled.div `
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.07em;
  color: #828282;
  opacity: 0.5;
  width: 100%;
  text-align: center;
  padding: 20px 0;
`

export const RequiredNoticeText = styled.div `
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.07em;
  color: #828282;
  opacity: 0.5;
  width: 100%;
  text-align: left;
  padding: 10px 0 20px 0;
`

export const ErrorText = styled.div `
  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.07em;
  color: red;
  opacity: 0.5;
  width: 100%;
  text-align: center;
  padding: 20px 0;
`

export const FullWidthWrapper = styled.div `
  width: 100%;
`

export const FullAreaWrapper = styled.div `
  width: 100%;
  height: 100%;
`

export const GridRow = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: ${ props => props.desktop };
  column-gap: 20px;

  ${cssVar.breakpoints.tablet} {
    grid-template-columns: ${ props => props.tablet };
    row-gap: ${ props => props.tabletRowGap ? '20px' : '0'};
  }

  ${cssVar.breakpoints.phone} {
    grid-template-columns: ${ props => props.phone };
    row-gap: ${ props => props.phoneRowGap ? '20px' : '0'};
  }
`

export const MaxContentWidthWrapper = styled.div `
  width: 100%;
  padding: 0 50px;
  overflow-y: hidden;

  ${cssVar.breakpoints.phone} {
    padding: 0 30px;
  }
`

export const MaxContentWidthContainer = styled.div `
  width: 100%;
  max-width: ${ cssVar.max_content_width }px;
  margin: 0 auto;
`

export const Section = styled(MaxContentWidthContainer) `
  padding: 75px 0;
`

export const SlightlySlimSection = styled(Section) `
  max-width: ${ cssVar.max_content_width - 200}px;
  padding: 50px 0;
`

export const SlimSection = styled(Section) `
  max-width: ${ cssVar.max_content_width - 400}px;
  padding: 50px 0;
`

export const FullWidthSection = styled.div `
  width: 100vw;
  margin-left: -50px;

  ${cssVar.breakpoints.phone} {
  margin-left: -30px;
  }
`

export const HeroSection = styled(FullWidthSection) `
  height: calc( 100vh - ${ cssVar.headerHeight }px );
  position: relative;
`


export const FullSizeBackgroundVideo = styled.div `
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  video, img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: ${ cssVar.colors.light_grey };
    filter: brightness(0.7);
  }
`


export const Spinner = styled.img `
  animation: spin 1.2s ease-in-out infinite;
  height: 100px;
  width: 100px;
  object-fit: contain;
`



export const HeroContentWrapper = styled(FullAreaWrapper) `
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
`

export const HeroText = styled(Text) `
  padding: 40px 0;
  color: white;
`

export const ScrollHint = styled.div `
  padding: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 20px;
  transition: all ${ cssVar.transitions.basic };
  text-decoration: none;

  :hover {
    transform: translate(-50%, -20px);
    text-decoration: none;
  }

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`

export const ScrollHintText = styled(LinkText) `
  color: ${ cssVar.colors.gold }
`

export const ScrollHintIcon = styled.img `
  padding: 0;
`

export const HeroSectionText = styled(withColor(BiggerText, '#FFFFFF')) `
  margin-bottom: 30px;
`



// WEBPACK FOOTER //
// /src/components/marketing/MarketingStyles.js